import { createFileRoute } from "@tanstack/react-router";
import SaintVsKetaminePage from "@/pages/learn/SaintVsKetaminePage";
import { pageSaintVsKetamine } from "@/pages/learn/learnDataSaintVsKetamine";
export const Route = createFileRoute("/learn/saint-vs-ketamine")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: pageSaintVsKetamine.title,
        },
        {
          name: "description",
          content: pageSaintVsKetamine.description,
        },
        {
          property: "og:title",
          content: pageSaintVsKetamine.title,
        },
        {
          property: "og:description",
          content: pageSaintVsKetamine.description,
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/learn/saint-vs-ketamine",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/saint-vs-ketamine",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageSaintVsKetamine.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintVsKetaminePage />;
}
